<div class="padding">
  <div>
    <div class="header">{{ 'add_student' | translate }}</div>
  </div>
  <div>
    <mat-icon class="close-icon" (click)="close()">close</mat-icon>
  </div>

  <form (ngSubmit)="create()" #form="ngForm" novalidate>
    <div class="flexColumn">

      <app-account-selector-input-async 
      (loadingSpinner)="loadingSpinnerEmit($event)"
      (selected)="accountChanged($event)" 
      (cleared)="accountCleared()">
      </app-account-selector-input-async>

      <mat-form-field appearance="fill">
        <mat-label>{{ 'first_name' | translate }}</mat-label>
        <input type="text" name="first_name" matInput #first_name="ngModel" placeholder="Student first_name"
          [(ngModel)]="student.first_name" maxlength="50">
        <mat-hint>{{student.first_name == null ? 0 : student.first_name?.length}}/50
          Characters</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>{{ 'last_name' | translate }}</mat-label>
        <input type="text" name="last_name" matInput #last_name="ngModel" placeholder="Student last_name"
          [(ngModel)]="student.last_name" maxlength="50">
        <mat-hint>{{student.last_name == null ? 0 : student.last_name?.length}}/50 Characters</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>{{ 'student_email' | translate }}</mat-label>
        <input type="email" rows="3" name="email_id" matInput #email_id="ngModel" placeholder="Student email_id"
         email required [(ngModel)]="student.email_id" maxlength="50">
        <mat-hint>{{student.email_id == null ? 0 : student.email_id?.length}}/50 Characters</mat-hint>
        <mat-error *ngIf="email_id.hasError('required')">{{ 'email_required' | translate }}</mat-error>
        <mat-error *ngIf="email_id.hasError('email')">{{ 'email_valid' | translate }}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>{{ 'folder_name' | translate }}</mat-label>
        <input type="text" name="folder_name" matInput #folder_name="ngModel" placeholder="Student folder_name" required
          [(ngModel)]="student.folder_name" pattern="^[\sa-zA-Z0-9\(\)_\-]+$" minlength="5" maxlength="30">
        <mat-hint>Minimum characters 5, {{student.folder_name == null ? 0 : student.folder_name?.length}}/30
          Characters</mat-hint>
        <mat-error *ngIf="folder_name.hasError('required')">{{ 'folderName_required' | translate }}</mat-error>
        <mat-error *ngIf="first_name.hasError('minlength')">{{ 'folderName_minLength' | translate }}</mat-error>
        <mat-error *ngIf="folder_name.hasError('pattern')">{{ 'characters_allowed' | translate }}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>{{ 'group_name' | translate }}</mat-label>
        <input type="text" name="group_name" matInput #group_name="ngModel" placeholder="Student group_name" required
          [(ngModel)]="student.group_name" pattern="^[\sa-zA-Z0-9\(\)_\-]+$" minlength="5" maxlength="30">
        <mat-hint>Minimum characters 5, {{student.group_name == null ? 0 : student.group_name?.length}}/30
          Characters</mat-hint>
        <mat-error *ngIf="group_name.hasError('required')">{{ 'groupName_required' | translate }}</mat-error>
        <mat-error *ngIf="first_name.hasError('minlength')">{{ 'groupName_minLength' | translate }}</mat-error>
        <mat-error *ngIf="group_name.hasError('pattern')">{{ 'characters_allowed' | translate }}</mat-error>
      </mat-form-field>

      <div class="saveRow">
        <a type="button" mat-raised-button (click)="cancel()">{{ 'cancel' | translate }}</a>
        <button type="submit" mat-raised-button color="primary" [disabled]="form.invalid">{{ 'save' | translate
          }}</button>
      </div>

    </div>
  </form>

</div>